export default __webpack_public_path__ + "static/media/ImageIcon.a7530e01.svg";